const categorySelects = document.querySelectorAll('[data-result-category-select]');

categorySelects.forEach((categorySelect) => {
    categorySelect.addEventListener('change', () => {
        if (categorySelect.value) {
            window.location.href = categorySelect.value;
        }
    });
});
